import React from "react";
import { Layout, Row, Col, Menu, Image, Typography, Divider, Tabs } from "antd";
import type { TabsProps } from "antd";
import styles from "./MarketPlace.module.scss";
import { TabInfo } from "./TabInfo";
import { Title } from "../Title/Title";
import SmartBuilding from "@assets/KPMG/infratech/SmartBuilding.svg";
import EV from "@assets/KPMG/infratech/EV.svg";
import SolarPanel from "@assets/KPMG/infratech/SolarPanel.svg";
import { mockDataMultiple } from "./mock";

const allProducts = [
  {
    description:
      "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward.",
    image: SmartBuilding,
    projects: mockDataMultiple.projectList.filter(
      (item: any, index: number) => item.solution === "Smart Building Solutions"
    ),
  },
  {
    description:
      "Our platform provide comprehensive solar panel solutions that seamlessly integrate into your building or residence. Our aim is to support the transition towards renewable energy by providing top-quality solar panels. Package listed are includes not just installation, but also monitoring and quality improvement to ensure optimal performance.",
    image: SolarPanel,
    projects: mockDataMultiple.projectList.filter(
      (item: any, index: number) => item.solution === "Solar Panel Solutions"
    ),
  },
  {
    description:
      "As EV usage increases in ASEAN, we offer comprehensive solutions for installing, monitoring, and operating EV charging systems in your residential or commercial building. We provide a one-stop-shop for all your needs.",
    image: EV,
    projects: mockDataMultiple.projectList.filter(
      (item: any, index: number) => item.solution === "EV Solutions"
    ),
  },
];

export const MarketPlace = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Smart Building Solutions`,
      children: <TabInfo data={allProducts[0]} />,
    },
    {
      key: "2",
      label: `Solar Panel Solutions`,
      children: <TabInfo data={allProducts[1]} />,
    },
    {
      key: "3",
      label: `EV Solutions`,
      children: <TabInfo data={allProducts[2]} />,
    },
  ];

  return (
    <>
      <div
        className="market-place"
        id="infratech-marketplace"
        style={{ padding: "0px 0" }}
      >
        <Row>
          {/* <Col lg={2} sm={24}></Col> */}
          <Col lg={24} sm={24} style={{}}>
            {/* <Title title="INFRATECH MARKETPLACE" width={800} /> */}
            <div style={{ marginTop: 20 }}>
              <Tabs type="card" defaultActiveKey="1" items={items} />
            </div>
          </Col>
          {/* <Col lg={2}></Col> */}
        </Row>
      </div>
    </>
  );
};
